module.exports = __webpack_public_path__ + "static/media/heart.bdb8d31b.png";